<template>
  <fragment>
    <div class="col-12 col-lg-8">
      <div>
        <button class="btn" :class="tab === 'personal' ? 'btn-primary dark' : 'btn-secondary'" @click="tab = 'personal'">Personal</button>
        <button class="btn" :class="tab === 'professional' ? 'btn-primary dark' : 'btn-secondary'" @click="tab = 'professional'">Professional</button>
        <button class="btn" :class="tab === 'documents' ? 'btn-primary dark' : 'btn-secondary'" @click="tab = 'documents'">Documents</button>
        <button class="btn" :class="tab === 'preferences' ? 'btn-primary dark' : 'btn-secondary'" @click="tab = 'preferences'">Preferences</button>
      </div>

      <div class="dashboard-card hard-angle">
        <personal-info v-if="tab === 'personal'" />
        <professional-info v-if="tab === 'professional'" />
        <official-documents v-if="tab === 'documents'" />
        <account-preferences v-if="tab === 'preferences'" />
      </div>
    </div>

    <div class="col-12 col-lg-4">
      <div class="dashboard-card">
        <h2 class="mb-3">Availability</h2>
        <p>
          Use this to update your availability or sync appointments across your
          calendars.
        </p>
        <router-link
          :to="{ name: 'availability' }"
          class="btn btn-primary btn-wide mt-3"
        >
          Edit Availability
        </router-link>
      </div>

      <div class="dashboard-card">
        <profile-photo-block>
          Upload a photo of yourself to personalize the BetterMynd experience
          for the students.
        </profile-photo-block>
      </div>

      <div class="dashboard-card">
        <security-block />
      </div>
    </div>
  </fragment>
</template>

<script>
import SecurityBlock from '@/users/account/components/SecurityBlock.vue';
import ProfilePhotoBlock from '@/users/account/components/ProfilePhotoBlock.vue';
import PersonalInfo from './CounselorAccount/personal-info.vue';
import ProfessionalInfo from './CounselorAccount/professional-info.vue';
import OfficialDocuments from './CounselorAccount/official-documents.vue';
import AccountPreferences from './CounselorAccount/AccountPreferences.vue';

export default {
  name: 'CounselorAccount',

  components: {
    SecurityBlock,
    ProfilePhotoBlock,
    PersonalInfo,
    ProfessionalInfo,
    OfficialDocuments,
    AccountPreferences
  },

  data() {
    return {
      tab: 'personal',
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-primary.dark {
  background-color: $dark-blue;
  border-color: $dark-blue;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  color:$white;
}
.btn-secondary:hover {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  color:$white;
}
.hard-angle {
  border-top-left-radius: 0px;
}
.account {
  .profile-button {
    @media (min-width: $md-min) {
      min-width: 150px;
    }
  }

  label {
    @include label;

    font-size: 12px;
  }

  h2 {
    margin-top: 10px;
    font-size: 28px;
    margin-bottom: 30px;
  }

  .replacement-label {
    text-transform: uppercase;
    font-size: 10px;
    opacity: 0.75;
    letter-spacing: 0.1rem;
    margin-bottom: 5px;
    color: white;
  }

  .upload-btn {
    width: 100%;
    margin-top: 10px;

    i,
    svg {
      margin-right: 7px;
    }
  }

  .right-lg {
    opacity: 0.75;
    position: relative;
    top: -8px;

    label {
      text-transform: none !important;
    }

    @media (min-width: $md-min) {
      text-align: right;
      top: 0;
    }
  }

  .add-file-btn {
    height: 45px;
    width: 100%;
    border-color: $green;
    background: none;
    color: $green;

    &:hover {
      border-color: $green;
      background: $green;
      color: #1c3a58;
    }
  }
}
</style>
